module.exports = __webpack_public_path__ + "stu-res/img/obbject-2-x@3x.0ff260fb.png";